import { render } from "./SetupGradeThresholds.vue?vue&type=template&id=025510fa"
import script from "./SetupGradeThresholds.vue?vue&type=script&lang=js"
export * from "./SetupGradeThresholds.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__